import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_rich",
  "use": "icon-control_rich-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_rich\"><g><g><path d=\"M8 3v1.2H2.698V3z\" /><path d=\"M6.038 3.419V9H4.757V3.419z\" /></g><path d=\"M9 3h5v1H9zM9 5.515h4.891v1.014H9zM9 8h5v1H9zM2 10.482h12v1.04H2zM2 13h12v1H2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol